import { Panel } from './Panel';
import { RadioButton } from '../ui';
import { LoadContext } from "../../../utils";
import { Sprite } from 'pixi.js';
import { Focusable, InteractiveWrapper } from "../../../ui";
import { Game } from '../../../game';

export class CoordinateEntry extends Panel
{
    private onButton:RadioButton;
    private offButton:RadioButton;

    public static preload() {
        LoadContext.current.add('Settings', './assets/accessibility/Settings{size}.json');
    }

    constructor( game:Game )
    {
        super(
            game,
            "Movement Controls",
            {
                title: "CYB_Panel3_MovementControls",
                explain: 'CYB_Panel3_CoordinatesYesNo',
                settings: 'CYB_Panel3_CoordinatesChoose',
            },
            {width: 830, height: 239}
        );

        const icon:Sprite = new Sprite( LoadContext.current.getSpritesheet('Settings').textures['icon_coordinates'] );
        icon.position.set( this.icon_x, this.icon_y );
        this.addChild( icon );

        this.onButton = new RadioButton( "Play Game With Coordinates" );
        this.onButton.position.set( 150, 120 );
        this.disposables.add(new InteractiveWrapper(this.onButton, {
            onHover: () => {
                this.game.vo.playHighlight('CYB_Panel3_Coordinates');
            },
            onFocus: () => {
                this.game.vo.playHighlight(['CYB_Panel3_Coordinates', 'CYB_Panel_SettingEdit']);
            },
            onTap: () => {
                this.game.vo.stop();
                this.turnOn(true);
                this.game.logEvent("change_setting", "movement_controls_coords");
                this.playRadioVO(this.onButton, 'CYB_Panel3_Coordinates');
            }
        }));
        this.addChild( this.onButton );

        this.offButton = new RadioButton( "Play Game Without Coordinates" );
        this.offButton.position.set( 150, 190 );
        this.disposables.add(new InteractiveWrapper(this.offButton, {
            onHover: () => {
                this.game.vo.playHighlight('CYB_Panel3_WithoutCoordinates');
            },
            onFocus: () => {
                this.game.vo.playHighlight(['CYB_Panel3_WithoutCoordinates', 'CYB_Panel_SettingEdit']);
            },
            onTap: () => {
                this.game.vo.stop();
                this.turnOn(false);
                this.game.logEvent("change_setting", "movement_controls_no_coords");
                this.playRadioVO(this.offButton, 'CYB_Panel3_WithoutCoordinates');
            }
        }));
        this.addChild( this.offButton );

        this.updateToMatchSetting();
    }

    private turnOn( value:boolean )
    {
        this.onButton.active = value;
        this.offButton.active = !value;

        if( value != this.settings.allowCoordinateEntry.value ) {
            this.settings.allowCoordinateEntry.value = value;
        }
    }

    getFocusItems():Focusable[]
    {
        let items = super.getFocusItems();
        return items.concat( [this.onButton, this.offButton] );
    }

    updateToMatchSetting()
    {
        super.updateToMatchSetting();
        this.turnOn( this.settings.allowCoordinateEntry.value );
    }

    destroy()
    {
        super.destroy();
    }
}